import { motion } from "framer-motion";
import { UserPlus, Wine, Heart } from "lucide-react";

const steps = [
  {
    icon: UserPlus,
    step: "01",
    title: "Create profile & choose event",
    description: "Pick your age band, venue area, and theme. Quick sign-up — no lengthy questionnaires.",
  },
  {
    icon: Wine,
    step: "02",
    title: "Attend the hosted evening",
    description: "Arrive at the venue. Your host guides icebreakers, 5–7 minute mini-dates, and social games.",
  },
  {
    icon: Heart,
    step: "03",
    title: "Get your mutual matches",
    description: "After the event, contacts are shared only when both people said yes or maybe. No awkward reveals.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="py-24 sm:py-32"
      data-testid="how-it-works-section"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <p className="font-mono text-xs tracking-[0.2em] uppercase font-semibold text-[hsl(var(--accent))] mb-4">
            The process
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-medium mb-16">
            How it works
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 lg:gap-12">
          {steps.map((step, i) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6, delay: i * 0.15 }}
              className="group"
              data-testid={`how-it-works-step-${i + 1}`}
            >
              <div className="bg-card border border-border/40 rounded-sm p-8 lg:p-12 h-full shadow-[0_8px_30px_rgb(0,0,0,0.04)] dark:shadow-none transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(0,0,0,0.08)] dark:hover:bg-card/80">
                <div className="flex items-center gap-4 mb-6">
                  <div className="w-12 h-12 rounded-sm bg-secondary flex items-center justify-center">
                    <step.icon className="w-5 h-5 text-[hsl(var(--accent))]" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-xs tracking-[0.2em] uppercase text-muted-foreground">
                    Step {step.step}
                  </span>
                </div>
                <h3 className="font-heading text-xl sm:text-2xl tracking-tight font-medium mb-3">
                  {step.title}
                </h3>
                <p className="text-base leading-relaxed text-muted-foreground">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
